import React from "react";

class Clock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false  })

        };
    }

    componentDidMount() {
        this.intervalID = setInterval(
            () => this.setState({
                time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })
            }),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    render() {
        return (
            <div className="local-time">
                {this.state.time}
            </div>
        );
    }
}

export { Clock };